import React, { Component } from 'react';

import Notifications from '../../../components/notifications/index';

export default class NotificationsScreen extends Component {
  render() {
    const { topicId } = this.props.match.params;
    return (
      <div>
        <Notifications topicId={topicId} />
      </div>
    );
  }
}
